// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__-k4We","error":"Textarea_error__2xvCf","readonly":"Textarea_readonly__-FHMq","disabled":"Textarea_disabled__3FN6-"};